import { createSlice } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getBaseTemplateByType, updateBaseTemplate } from './actionCreators';
import { LLMTemplateDetailsState, SLICE_NAME, initialState } from './models';

export const llmTemplateDetailsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBaseTemplateByType.pending, (state: LLMTemplateDetailsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBaseTemplateByType.fulfilled, (state: LLMTemplateDetailsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.template = payload;
      })
      .addCase(getBaseTemplateByType.rejected, (state: LLMTemplateDetailsState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      })
      .addCase(updateBaseTemplate.pending, (state: LLMTemplateDetailsState) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(updateBaseTemplate.fulfilled, (state: LLMTemplateDetailsState, action) => {
        const { payload } = action;
        state.isSaving = false;
        state.template = payload;
      })
      .addCase(updateBaseTemplate.rejected, (state: LLMTemplateDetailsState, action) => {
        const { error } = action;
        state.isSaving = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
